import httpService from "@/components/service";
import currentBrand from "@/services/currentBrand";
export const brand = {
    namespaced: true,
    state: {
        brand: {},
        zones: [],
        campaigns: [],
        brands: [],
        access: null
    },
    getters: {
        getBrand: state => state.brand,
        getZones: state => state.zones,
        getCampaigns: state => state.campaigns,
        getTheme(state) {
            return state.brand.theme !== null ? state.brand.theme : "light";
        },
        getLogo: state => state.brand.logo,
        getLogoRem3rch: state => state.brand.thirdColor,
        getBackgroundColor: state => state.brand.backgroundColor,
        getLinksColor: state => state.brand.linksColor,
        getAllBrands(state) {
            return state.brands;
        },
        getBrandAccess(state) {
            return state.access;
        }
    },
    mutations: {
        POPULATE_BRAND(state, data) {
            state.brand = data;
        },
        SET_ZONES(state, zones) {
            state.zones = zones;
        },
        SET_CAMPAIGNS(state, campaigns) {
            state.campaigns = campaigns;
        },
        SET_THEME(state, theme) {
            state.brand.theme = theme;
        },
        FIND_ALL_BRANDS(state, brands) {
            state.brands = brands;
        },
        FIND_BRAND_ACCESS(state, access) {
            state.access = access;
        },
        CLEAR_ACCESS(state) {
            state.access = null;
        }
    },
    actions: {
        async populate(context) {
            const brand = await currentBrand.get();
            context.commit("POPULATE_BRAND", brand);
        },
        async populateZones(context) {
            const res = await httpService.get("/zones/list?limit=200");
            context.commit("SET_ZONES", res.data);
            return res.data;
        },
        async populateCampaigns(context) {
            const res = await httpService.get("/admin/campaigns/list");
            context.commit("SET_CAMPAIGNS", res.data);
            return res.data;
        },
        setTheme(context, theme) {
            context.commit("SET_THEME", theme);
        },
        findAllBrands(context) {
            httpService.get("/admin/brands").then(data => {
                context.commit("FIND_ALL_BRANDS", data.data);
                return data.data;
            });
        },
        findBrandAccess(context, id) {
            return httpService.get("/admin/brands/" + id + "/access").then(data => {
                context.commit("FIND_BRAND_ACCESS", data.brandAccesses);
                return data;
            });
        },
        clearAccess(context) {
            context.commit("CLEAR_ACCESS");
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/brand/brand.js